import { NavLink, Link } from "react-router-dom";
import Logo from "../../images/first_light_adventure_final.png";
import MobileMenu from "./MobileMenu";

const Header = () => {
    return (
        <>
            <nav className="navbar">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand d-flex me-auto sitelogo"><img src={Logo} title="" alt="" /></Link>
                    <MobileMenu />
                    <div>

                        <ul className="navbar-links">
                            <li className="nav-item">
                                <NavLink to="/" className="nav-link"> Home </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/explore/expeditions" className="nav-link"> Explore </NavLink>
                                <ul>
                                    <li><NavLink to="/explore/expeditions" className="nav-link" > Expeditions </NavLink></li>
                                    <li><NavLink to="/explore/experiences" className="nav-link"> Experiences </NavLink></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/about" className="nav-link"> About </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/contact" className="nav-link"> Contact </NavLink>
                            </li>
                        </ul>


                    </div>




                </div>
            </nav>

        </>
    )
};

export default Header;